import { useCallback } from "react";
import type { Transition } from "history";
import useBlocker from "./useBlocker";

/*
  NOTE: React router v6 currently doesn't natively support usePrompt compared to
  previous major versions. This will need to be removed once v6 provides the relavant
  blocking capabilities.
*/

/**
 * @source https://github.com/remix-run/react-router/issues/8139#issuecomment-1021457943
 */
function usePrompt(
  message:
    | string
    | ((
        location: Transition["location"],
        action: Transition["action"],
      ) => boolean),
  when = true,
) {
  const blocker = useCallback(
    (tx: Transition) => {
      let response;
      if (typeof message === "function") {
        response = message(tx.location, tx.action);
        if (typeof response === "string") {
          response = window.confirm(response);
        }
      } else {
        response = window.confirm(message);
      }

      if (response) {
        tx.retry();
      }
    },
    [message, when],
  );

  return useBlocker(blocker, when);
}

export default usePrompt;
